var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorCloudStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 256,
    width: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    transform: "rotate(0,128,128) translate(10,55.1903331989248) scale(7.37500043958428,7.37500043958428)  ",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "#747D82",
    d: "M18.782438,9.9638113E-05C19.432438,-0.0029063734 19.845443,0.063102809 19.845443,0.063102697 27.017511,0.58009841 27.351515,7.9140603 27.351515,7.9140603 37.810604,13.855023 27.351515,19.744993 27.351515,19.744993L5.0483157,19.744993C-0.7937388,18.813005 0.041267657,13.288026 0.041267803,13.288026 0.094269527,8.173061 4.6603119,7.7610609 4.6603119,7.7610609 4.769314,4.7650744 6.9373324,4.0410792 6.9373324,4.0410792 9.8303554,3.0090867 11.612369,4.4030768 11.612369,4.4030768 13.36639,0.5340934 16.984419,0.0071033405 18.782438,9.9638113E-05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorCloudStep);
export default __webpack_public_path__ + "static/media/ConnectorCloudStep.df3c9af8bbb69f16f792b30bc9d63db8.svg";
export { ForwardRef as ReactComponent };